import { apiSlice } from './apiSlice';

export const blogsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBlogByUsernameAndSlug: builder.query({
      query: ({ username, slug }) => ({
        url: `/blog/${username}/${slug}`,
        method: 'GET',
      }),
    }),
    listBlogsByUsername: builder.query({
      query: (username) => ({
        url: `/blog/${username}`,
        method: 'GET',
      }),
    }),
    createBlog: builder.mutation({
      query: (body) => ({
        url: `/blog`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => [],
    }),
  }),
});

export const { useGetBlogByUsernameAndSlugQuery, useListBlogsByUsernameQuery, useCreateBlogMutation } = blogsApiSlice;


